import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-1" };
const _hoisted_3 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_4 = {
    key: 0,
    class: "rounded-lg border border-ewhite-200 bg-white p-4 text-sm text-eblack-600"
};
const _hoisted_5 = {
    key: 1,
    class: "rounded-lg border border-ewhite-200 bg-white p-4 shadow-sm"
};
const _hoisted_6 = { class: "flex flex-col gap-2 text-sm font-medium text-eblack-700" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "flex flex-col gap-2 text-sm font-medium text-eblack-700" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = ["value"];
const _hoisted_11 = {
    key: 0,
    class: "rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600"
};
const _hoisted_12 = { class: "flex flex-wrap gap-2" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    key: 2,
    class: "text-sm text-eblack-500"
};
import { computed, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { IconDeviceFloppy } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { useAuthStore } from "@/domains/auth";
import { useOrganizationStore } from "@/domains/organization";
import { utilityEmailLanguageOptions } from "@/shared/language/language-preferences";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganizationProfileIndex',
    setup(__props) {
        const toast = useToast();
        const authStore = useAuthStore();
        const organizationStore = useOrganizationStore();
        const { t } = useI18n();
        const form = reactive({
            display_name: "",
            default_language: "es",
        });
        const formError = ref(null);
        const orgId = computed(() => authStore.currentOrgId ? Number(authStore.currentOrgId) : null);
        const isLoading = computed(() => organizationStore.isLoading);
        const isSaving = computed(() => organizationStore.isSaving);
        const organizationRequestContext = computed(() => ({
            orgContext: authStore.isSuperAdmin ? "global" : "tenant",
        }));
        onMounted(load);
        async function load() {
            if (!orgId.value)
                return;
            form.display_name =
                authStore.currentOrgName ||
                    organizationStore.byId(orgId.value)?.display_name ||
                    "";
            try {
                const organization = await organizationStore.fetchOrganization(orgId.value, organizationRequestContext.value);
                assignOrganization(organization);
            }
            catch {
                formError.value = t("settings.organization_profile.load_error");
            }
        }
        async function save() {
            if (!orgId.value)
                return;
            const displayName = form.display_name.trim();
            if (!displayName) {
                formError.value = t("settings.organization_profile.name_required");
                return;
            }
            formError.value = null;
            try {
                const organization = await organizationStore.updateOrganization(orgId.value, {
                    display_name: displayName,
                    default_language: form.default_language || "es",
                }, organizationRequestContext.value);
                assignOrganization(organization);
                updateAuthContextName(organization.display_name);
                toast.success(t("settings.organization_profile.save_success"));
            }
            catch {
                formError.value = t("settings.organization_profile.save_error");
            }
        }
        function assignOrganization(organization) {
            form.display_name = organization.display_name;
            form.default_language = organization.default_language || "es";
        }
        function updateAuthContextName(displayName) {
            authStore.memberships = authStore.memberships.map((membership) => String(membership.org_id) === String(orgId.value)
                ? { ...membership, org_name: displayName }
                : membership);
            authStore.contexts = authStore.contexts.map((context) => String(context.org_id) === String(orgId.value)
                ? { ...context, org_name: displayName }
                : context);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("settings.organization_profile.title")), 1)
                ]),
                (!orgId.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)("settings.organization_profile.select_org")), 1))
                    : (_openBlock(), _createElementBlock("section", _hoisted_5, [
                        _createElementVNode("form", {
                            "data-test": "organization-profile-form",
                            class: "flex max-w-2xl flex-col gap-4",
                            onSubmit: _withModifiers(save, ["prevent"])
                        }, [
                            _createElementVNode("label", _hoisted_6, [
                                _createTextVNode(_toDisplayString(_unref(t)("settings.organization_profile.display_name")) + " ", 1),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.display_name) = $event)),
                                    "data-test": "organization-display-name",
                                    type: "text",
                                    autocomplete: "organization",
                                    class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500",
                                    disabled: isSaving.value || isLoading.value
                                }, null, 8, _hoisted_7), [
                                    [_vModelText, form.display_name]
                                ])
                            ]),
                            _createElementVNode("label", _hoisted_8, [
                                _createTextVNode(_toDisplayString(_unref(t)("settings.organization_profile.default_language")) + " ", 1),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.default_language) = $event)),
                                    "data-test": "organization-default-language",
                                    class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500",
                                    disabled: isSaving.value || isLoading.value
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(utilityEmailLanguageOptions), (language) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: language.value,
                                            value: language.value
                                        }, _toDisplayString(language.label), 9, _hoisted_10));
                                    }), 128))
                                ], 8, _hoisted_9), [
                                    [_vModelSelect, form.default_language]
                                ])
                            ]),
                            (formError.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(formError.value), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("button", {
                                    type: "submit",
                                    "data-test": "save-organization-profile",
                                    class: "inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-egreen-500 px-4 text-sm font-medium text-white disabled:opacity-60",
                                    disabled: isSaving.value || isLoading.value
                                }, [
                                    _createVNode(_unref(IconDeviceFloppy), { class: "h-4 w-4" }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("common.actions.save")), 1)
                                ], 8, _hoisted_13)
                            ])
                        ], 32)
                    ])),
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_unref(t)("settings.organization_profile.loading")), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
